import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { DEL, POST } from "config/api.config";

/** POST `Report/ready-to-send/filter` */
export const submitReadyToSendReportFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.READY_TO_SEND_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** DELETE `Report/ready-to-send/{id}` */
export const deleteReadyToSendReportItem = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) return null;
  try {
    const response = await DEL(REPORT.READY_TO_SEND_BY_ID(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
